import { findPath } from "@/mocks/home";

export default function FindPath() {
  return (
    <section id="guide" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-700">
            05 / FINDING PATH
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
            资源大全的查找路径
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            与其在平台里漫无目的地翻找，不如按下面三步走：分区定范围、索引缩选项、合集取成套。多数需求在前两步就能定位到目标内容。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {findPath.map((item, index) => (
            <div
              key={item.step}
              className="relative flex flex-col rounded-lg border border-background-300 bg-background-100 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-bold text-accent-600">
                  {item.step}
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i
                    className={
                      index === 0
                        ? "ri-layout-grid-line text-lg"
                        : index === 1
                          ? "ri-list-check-2 text-lg"
                          : "ri-stack-line text-lg"
                    }
                  />
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}